module.exports = __webpack_public_path__ + "static/media/newgen.ae0fac0a.png";